import classNames from "classnames";
import { getWowStatic } from "hooks/wow/getStaticData";
import React from "react";
import { sigfigFormatter } from "../../../lib/tierHelper";
import WowTooltip from "../../Tooltips/WowTooltip";

const TrinketPair = (props) => {
  const { trinket, selectedTrinket: selectedTrinketInput, encounterType, isHealer, nested } = props;
  const { item_id: id, count, hps, dps, max_key = 0, quality } = trinket;

  const currentStaticData = getWowStatic("item", id);
  const selectedTrinketData = getWowStatic("item", selectedTrinketInput?.item_id);
  const selectedTrinket = selectedTrinketData || selectedTrinketInput;
  const primaryStat = isHealer ? hps : dps;

  return currentStaticData ? (
    <div className={classNames("grid row pairs", { nested: nested })}>
      <div className="trinket-name">
        <WowTooltip type="item" id={selectedTrinket?.id}>
          <div className="trinket-img">
            <img src={selectedTrinket?.img} alt={selectedTrinket?.name} />
          </div>
        </WowTooltip>
        <WowTooltip type="item" id={id}>
          <div className="trinket-img">
            <img src={currentStaticData.img} alt={currentStaticData.name} />
          </div>
        </WowTooltip>
        {/* <span style={{ color: getItemQualityColor(quality) }}>{currentStaticData?.name}</span> */}
        <span style={{ color: "rgb(163, 53, 238)" }}>{currentStaticData?.name}</span>
      </div>
      <div className="data-text">
        {encounterType === "raid"
          ? sigfigFormatter(primaryStat)
          : encounterType === "PvP"
          ? trinket.max_rating ?? 0
          : `+${max_key}`}
      </div>
      <div className="data-text popularity">
        <div>{trinket.perc}%</div>
        <div className="count">({count})</div>
      </div>
    </div>
  ) : null;
};

export default TrinketPair;
